import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { ChartTwoIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { toast } from 'sonner'

import { createBudgetAllocation } from '../../api/buget-allocation/create-buget-allocation'
import UserNavBar from '../../components/elements/nav-bar'
import BudgetAllocationForm from '../../components/pages/budget-allocations/budget-allocation-form'
import { Paths } from '../../lib/constants/path'
import { updateButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const BudgetAllocationCreatePage = () => {
  const { navigate } = useNavigator()
  const [formKey, setFormKey] = useState(0) // Using form key to reset the form since we are on the same page

  const { mutateAsync } = useMutation({
    mutationFn: createBudgetAllocation,
    onError: showAxiosError,
    onSuccess: () => toast.success('Ligne budgétaire créée avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer une nouvelle ligne budgétaire'} icon={ChartTwoIcon} />
      <div className={'h-4'} />

      <Box>
        <BudgetAllocationForm
          key={formKey}
          buttonsConfig={updateButtonsConfig({
            onUpdateThenCreate: async (values) => {
              await mutateAsync(values)
              setFormKey((prev) => prev + 1)
            },
            onUpdateThenList: async (values) => {
              await mutateAsync(values)
              navigate(Paths.BUDGET_ALLOCATION_LIST_PAGE, { replace: true })
            },
            onCancel: () => navigate(Paths.BUDGET_ALLOCATION_LIST_PAGE, { replace: true })
          })}
        />
      </Box>
    </div>
  )
}

export default BudgetAllocationCreatePage
